export const color = {
  THEME: "#30b4ac",
  WHITE: "#ffffff",
  ERROR: "#ff4d4f",
  DISABLED: "#a9a9a9",
  GRAY: "#d9d9d9",
  BLACK: "#000000",
  LINK: "#1890ff",
  SUCCESS: "#87d068",
  WARNING: "#FFC700",
  MYCOLOR: "#30b4ac",
  OTHERSCOLOR: "#C5C5C5",
  NOPTCOLOR: "#FFC700",
  LIGHTGREEN: "#aee6cb",
  DARKGRAY: "#555555",
};
